import {DialogManager} from '@modifi/plugin-dialogs'
import {DIALOG_SHIPMENT_TRACKING_DETAILS} from './constants'

import ShipmentTrackingDetailsDialog from './dialog'

DialogManager.addDialog(DIALOG_SHIPMENT_TRACKING_DETAILS, ShipmentTrackingDetailsDialog)

export * from './index'
